// 면접 스케줄용 드롭다운 (기본 html select 대신 MUI Select로 목록을 디자인)
import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

interface Props {
    value: string;
    options: { value: string, label: string }[];
    onChange: (value: string) => void;
    placeholder?: string;
    height?: number;
    fullWidth?: boolean;
    id?: string;
}

const InterviewSelect: React.FC<Props> = ({ value, options, onChange, placeholder, height = 44, fullWidth, id }) => {
    return (
        <Select
            id={id}
            value={value}
            displayEmpty
            fullWidth={fullWidth}
            onChange={(e) => onChange(e.target.value as string)}
            renderValue={(v: any) => {
                const found = options.find((o) => o.value === v);
                if (found) return found.label;
                return <span style={{ color: "#9a9a9a" }}>{placeholder || ""}</span>;
            }}
            sx={{
                height, minWidth: 130, bgcolor: "#fff", borderRadius: "8px",
                fontFamily: "Apple_R", fontSize: 13, color: "#222",
                "& .MuiSelect-select": { py: 0, pl: "12px", display: "flex", alignItems: "center", height: "100%" },
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c9c9c9" },
                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#3346A6" },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#3346A6", borderWidth: "1px" },
                "& .MuiSelect-icon": { color: "#666" },
            }}
            MenuProps={{
                PaperProps: {
                    sx: {
                        mt: "6px", borderRadius: "12px", border: "1px solid #e1e4ee",
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)", maxHeight: 340,
                        "& .MuiList-root": { p: "6px" },
                    },
                },
            }}
        >
            {options.map((o) => (
                <MenuItem
                    key={o.value}
                    value={o.value}
                    sx={{
                        fontFamily: "Apple_R", fontSize: 13, color: "#222", borderRadius: "8px", minHeight: 36, px: "12px",
                        "&:hover": { bgcolor: "#f4f6fb" },
                        "&.Mui-selected": { bgcolor: "#eaedf8", color: "#3346A6", fontFamily: "Apple_B" },
                        "&.Mui-selected:hover": { bgcolor: "#dfe4f6" },
                    }}
                >
                    {o.label}
                </MenuItem>
            ))}
        </Select>
    );
};

export default InterviewSelect;
